import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import CommercialFileStatusEnum from '../../models/enums/commercialFileStatusEnum';
import CommercialFileEnergyStatusEnum from '../../models/enums/commercialFileStatusEnergyEnum';
import RoleEnum from '../../models/enums/roleEnum';
import CommercialFileEnergyEtatEnum from '../../models/enums/commercialFileEnergyEtatEnum';

@Component({
    selector: 'app-select-status',
    templateUrl: './select-status.component.html',
    styleUrls: ['./select-status.component.scss']
})
export class SelectStatusComponent implements OnInit, OnDestroy, OnChanges {

    @Input() type;

    @Input() multiple = false;
    @Input() disabled = false;
    @Input() placeholder: string;
    @Input() selectedStatus: any[] = [];

    @Output() onSelectStatus = new EventEmitter<any>();

    currentCompany: any;
    statusList: any[] = [];
    loading = false;

    currentUser: any;

    constructor() { }

    ngOnInit() {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (this.type === 'CALO') {
            this.statusList = CommercialFileStatusEnum.getListLabes();
        }
        if (this.type === 'ENERGY') {
            this.statusList = CommercialFileEnergyStatusEnum.getListLabes();
            this.statusList.unshift(new CommercialFileEnergyStatusEnum('POSITIVE', 'POSITIVE', 'bruillon_badge', [], 'ENERGY', 'green'));
        }
        if (this.type === 'CPF') {
            this.statusList = [];
        }
    }

    ngOnDestroy() {
    }

    ngOnChanges(changes: SimpleChanges) {
    }

    onChange(event) {
        this.onSelectStatus.emit(event);
        this.selectedStatus = event;
    }

}
